<mat-toolbar class="p-0 mat-elevation-z1">

    <div fxFlex fxFill fxLayout="row" fxLayoutAlign="start center">

        <div fxFlex="1 0 auto" fxLayout="row" fxLayoutAlign="start center">

            <button mat-icon-button class="navbar-toggle-button"
                    *ngIf="!hiddenNavbar && !rightNavbar" (click)="toggleSidebarOpen('navbar')" fxHide.gt-md>
                <mat-icon class="secondary-text">menu</mat-icon>
            </button>

            <div class="toolbar-separator" *ngIf="!hiddenNavbar && !rightNavbar" fxHide.gt-md></div>

            <div fxLayout="row" fxLayoutAlign="start center">
                <div class="logo ml-16 mr-16">
                    <img class="logo-icon" src="assets/images/logos/logo.svg">
                </div>
                <div [style.cursor]="'pointer'" [routerLink]="['']">Portal de Serviços | Mobit Brasil</div>
            </div>

        </div>

        <div class="" fxFlex="0 1 auto" fxLayout="row" fxLayoutAlign="start center">

            <button mat-button [matMenuTriggerFor]="userMenu"
                    class="user-button">
                <div fxLayout="row" fxLayoutAlign="center center">
                    <mb-user-photo class="font-weight-100" *ngIf="loggedUser" [user]="loggedUser"></mb-user-photo>
                    <span class="username mr-12 ml-16" fxHide fxShow.gt-sm>{{loggedUser | userFullName}}</span>
                    <mat-icon class="s-16" fxHide.xs>keyboard_arrow_down</mat-icon>
                </div>
            </button>

            <mat-menu #userMenu="matMenu" [overlapTrigger]="false">

                <button mat-menu-item [routerLink]="['perfil']">
                    <mat-icon>account_circle</mat-icon>
                    <span>Perfil</span>
                </button>
                <button mat-menu-item (click)="logout()">
                    <mat-icon>exit_to_app</mat-icon>
                    <span>Sair</span>
                </button>

            </mat-menu>

            <div class="toolbar-separator" fxHide fxShow.gt-xs></div>

            <button mat-icon-button class="navbar-toggle-button"
                    *ngIf="!hiddenNavbar && rightNavbar" (click)="toggleSidebarOpen('navbar')" fxHide.gt-md>
                <mat-icon class="secondary-text">menu</mat-icon>
            </button>

            <div class="toolbar-separator"></div>

            <button mat-icon-button
                    aria-label="Toggle fullscreen"
                    (click)="toggleFullScreenMode()"
                    [matTooltip]="fullScreenTooltip">
                <mat-icon class="secondary-text">{{fullScreenIcon}}</mat-icon>
            </button>

            <mb-app-menu></mb-app-menu>

        </div>

    </div>

</mat-toolbar>